import React from "react";
import { IconButton } from "@material-ui/core";
import { Link } from "react-router-dom";

const IconItems = ({ icons, iconStyle, groupStyle }) => {
  return (
    <div className={groupStyle}>
      {icons.map(({ icon, link }, index) => (
        <Link to={link} key={index}>
          <IconButton className={iconStyle}>{icon}</IconButton>
        </Link>
      ))}
    </div>
  );
};

export default IconItems;
